<template>
  <div>
    <header-ton @boxLogin="IsUsersLogin" :actived="1"></header-ton>
    <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
    <div style="margin-top: 80px;">
      <img class="brand-img" src="../../../public/images/bg/5.png" height="460" alt />
    </div>
    <div class="hotMeau">
      <div :class="class_id == 0 ? 'li active' : 'li'" @click="getSubject(0)">热门题库</div>
      <div :class="class_id == item.id ? 'li active' : 'li'" @click="getSubject(item.id)"
        v-for="(item, index) in columnData" :key="index">{{ item.title }}</div>
    </div>

    <div class="columns">
      <div v-for="(item, index) in subjectData" :key="index">
        <div class="title">
          {{ item.title }}
        </div>
        <div class="subject">公共科目</div>
        <div class="chapter">
          <div :class="subject_id == items.id ? 'li active' : 'li'" @click="goSubject(items, item.par_id)"
            v-for="(items, idx) in item.public" :key="idx">{{ items.title }}
          </div>
        </div>
        <div class="speciality" v-if="item.subject.length > 0">专业科目</div>
        <div class="chapter">
          <div :class="subject_id == items.id ? 'li active' : 'li'" @click="goSubject(items, item.par_id)"
            v-for="(items, idx) in item.subject" :key="idx">{{ items.title }}
          </div>
        </div>
      </div>
    </div>
    <booter-ton></booter-ton>
  </div>
</template>

<script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
import LoginBox from "@/components/LoginBox";
export default {
  components: {
    HeaderTon,
    BooterTon,
    LoginBox,
  },
  data() {
    return {
      showLogin: false,
      columnData: [],
      subjectData: [],
      keywords: "",
      loading: true,
      limit: 6,
      class_id: 0,
      subject_id: 0,
    };
  },
  mounted() {
    let ids = sessionStorage.getItem("access-class_id");
    if (ids) {
      this.class_id = ids;
    }
    this.subject_id = sessionStorage.getItem("access-subject_id");
    this.getList();
    this.getColumnList();
  },
  methods: {

    //判断是否登录
    IsUsersLogin() {
      let token = sessionStorage.getItem("access-token");
      console.log(token);
      if (token) {
        return true;
      } else {
        this.showLogin = true;
        this.$refs.login.getMiQrCode();
        return false;
      }
    },

    closeBox(e) {
      console.log(e);
      this.showLogin = false;
    },

    getSubject(e) {
      this.class_id = e;
      sessionStorage.setItem("access-class_id", e);
      this.getColumnList();
    },

    goSubject(e, par_id) {
      sessionStorage.setItem("access-class_id", par_id);
      sessionStorage.setItem("access-column_id", e.column_id);
      sessionStorage.setItem("access-subject_id", e.id);
      this.subject_id = e.id;
      this.$router.push("/web/chapter");
    },

    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      formData.column_id = that.column_id;
      formData.limit = that.limit;
      that.axios.post("/getColumnCate", formData).then((res) => {
        if (res) {
          that.columnData = res.data;
          that.loading = false;
        }
      });
    },

    getColumnList() {
      let that = this;
      let formData = {};
      formData.class_id = that.class_id;
      that.axios.post("/getColumnList", formData).then((res) => {
        if (res) {
          that.subjectData = res.data;
          that.loading = false;
        }
      });
    },
  },
};
</script>

<style>
page {
  background: #f7f7f7;
}

.hotMeau {
  margin: 10px auto;
  width: 1200px;
  height: 60px;
  background: #ffffff;
  border-radius: 0px;
  display: flex;
  flex-direction: row;
  padding: 20px 0;
  text-align: center;
}

.hotMeau .li {
  width: 10%;
  cursor: pointer;
}

.hotMeau .active {
  color: #4171f9;
  font-weight: bold;
}

.columns {
  width: 1200px;
  margin: 0 auto;
  padding: 49px 15px 15px 15px;
  background: url(../../../public/images/bg/6.png) no-repeat top center;
  background-color: #ffffff;
}

.columns .title {
  font-size: 24px;
  font-weight: bold;
  line-height: 66px;
}

.columns .subject {
  color: #717686;
  background: url(../../../public/images/icon/public.png) no-repeat center left;
  padding-left: 30px;
  font-size: 16px;
  line-height: 30px;
  margin-bottom: 10px;
}

.columns .speciality {
  color: #717686;
  background: url(../../../public/images/icon/speciality.png) no-repeat center left;
  padding-left: 30px;
  font-size: 16px;
  line-height: 30px;
  margin-bottom: 10px;
}

.columns .chapter {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.columns .chapter .li {
  width: 24%;
  height: 48px;
  background: #f9f9f9;
  border-radius: 5px;
  text-align: center;
  line-height: 48px;
  font-size: 15px;
  font-weight: 400;
  color: #222222;
  margin-bottom: 15px;
  cursor: pointer;
  margin-right: 10px;
}

.columns .chapter .li:hover {
  background-color: #4171f9;
  color: #f7f7f7;
}

.columns .chapter .li.active {
  background-color: #4171f9;
  color: #f7f7f7;
}
</style>